<template lang="pug">
form(class='file-upload' ref='form')
  div(class='file-upload-wrap')
    v-text-field(
      :label='label'
      v-model='name'
      prepend-icon='attach_file'
      hint='Максимальный размер файла 60Мб'
      persistent-hint
    )
    input(@change='readFile' accept='*' type='file' ref='image')
    div(v-if='value.url' class='file')
      div(class='name')
        div(class='file-name')
          a(:href='value.url' target='_blank') {{value.url}}
      div(class='ctrl')
        v-tooltip(top)
          v-btn(@click.stop='remove' slot='activator' icon)
            v-icon delete_outline
          | Удалить
  v-dialog(
    v-model='busy'
    persistent
    width='280'
  )
    v-card(color='primary' dark)
      v-card-text Загрузка файла
      v-progress-linear(v-model="progress" color='white' class='mb-0')
</template>

<script>
import http from '@/http'

export default {
  props: {
    label: {
      type: String,
      default: 'Выберите файл для загрузки'
    },
    parseResponse: {
      type: Function,
      default: v => v
    },
    recordId: {
      type: Number,
      default: null
    },
    value: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    name: null,
    busy: false,
    progress: 0
  }),

  methods: {
    async upload(file) {
      if (this.busy) return
      this.busy = true

      this.$emit('upload-start')

      let formdata = new FormData()
      // formdata.append('attachFile', file, file.name)
      formdata.append('jsonscheme', file, file.name)

      try {
        let response = await http.post('/files/upload/scheme/file', formdata, {
          onUploadProgress: progressEvent => {
            let totalLength = progressEvent.lengthComputable
              ? progressEvent.total
              : progressEvent.target.getResponseHeader('content-length') ||
                progressEvent.target.getResponseHeader(
                  'x-decompressed-content-length'
                )
            if (totalLength !== null) {
              let progress = Math.round(
                (progressEvent.loaded * 100) / totalLength
              )
              this.progress = progress
              this.$emit('upload-progress', progress)
            }
          }
        })
        this.$emit('input', this.parseResponse(response.data))
        this.$emit('upload-success', response.data)
      } catch (error) {
        this.$emit('upload-error', error)
      }

      this.busy = false
      this.progress = 0
    },

    async remove() {
      if (this.busy || !(await this.$confirm('Удалить?'))) return

      this.busy = true

      this.$emit('remove-start')

      try {
        const hash =
          typeof this.$attrs.value === 'string'
            ? this.$attrs.value
            : this.$attrs.value.hash

        let response = await http.post(`/files/delete/${hash}`, {
          record_id: this.recordId
        })

        this.$emit('input', null)
        this.$emit('remove-success', response)
        this.$nextTick(() => this.$refs.form.reset())
      } catch (error) {
        this.$emit('remove-error', error)
      }

      this.busy = false
    },

    readFile(event) {
      let file = event.target.files[0]
      if (file) {
        this.name = file.name
        this.$refs.form.reset()
        this.upload(file)
      } else {
        this.$root.showSnack('Неподдерживаемый формат файла')
      }
    }
  }
}
</script>

<style scoped>
.file-upload-wrap {
  overflow: hidden;
  position: relative;
}
.file-upload [type='file'] {
  top: 0;
  left: 0;
  opacity: 0;
  font-size: 50px;
  position: absolute;
}
.file {
  display: flex;
  padding-left: 33px;
  align-items: center;
}
.name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ctrl {
  padding-left: 24px;
}
.file-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
